import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { Empty, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import { active, inActive } from "../Dashboard/icons";
import Td from "../common/Td";

export default function UserFleetList({ fleets, userId }) {
  const navigate = useNavigate();

  return (
    <div className="mt-6">
      <table className="table">
        <thead className="border-b-2 border-base-300">
          <tr className="text-[#B1B1B1] text-[15px] font-[700] leading-[35px]">
            <th>Fleet name</th>
            <th>
              <div className="flex gap-2 items-center">
                <img src={active} alt="active" /> Online
              </div>
            </th>
            <th>
              <div className="flex gap-2 items-center">
                <img src={inActive} alt="inactive" /> Offline
              </div>
            </th>
            <th>Active</th>
            <th>Inactive</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody className="mt-3">
          {fleets?.length ? (
            <>
              {fleets.map((fleet) => {
                return (
                  <tr
                    onClick={() =>
                      navigate(
                        `/users/${userId}/fleets/${fleet.fleet_id}/devices`
                      )
                    }
                    key={fleet.id}
                    className="shadow-[0_3.5px_5.5px_0_#00000005] h-16 cursor-pointer"
                  >
                    <Td className={"rounded-l-[15px]"}>{fleet.thing_group}</Td>
                    <Td>{fleet.online_count}</Td>
                    <Td>{fleet.device_count - fleet.online_count}</Td>
                    <Td>{fleet.active_count}</Td>
                    <Td>{fleet.device_count - fleet.active_count}</Td>
                    <Td className={"rounded-r-[15px]"}>{fleet.device_count}</Td>
                  </tr>
                );
              })}
            </>
          ) : (
            <tr>
              <td colSpan="5" className="text-[20px] text-center">
                <Empty />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
